import {
	BUTTON_FACTORY_BUSY,
	INITIALIZE_WIZARD,
	WIZARD_CONTINUE,
	WIZARD_BACK,
	WIZARD_SET_CURRENT_PAGE,
	CREATE_BUTTON_SUCCESS,
	CREATE_BUTTON_ERROR,
	EDIT_BUTTON_SUCCESS,
	EDIT_BUTTON_ERROR,
	GET_BUTTON_DATA_SUCCESS,
	GET_BUTTON_DATA_ERROR,
	UPDATE_CODE_SNIPPET,
	TURN_ON_SPINNER,
	TURN_OFF_SPINNER,
	SHOW_LOGIN_MODAL,
	HIDE_LOGIN_MODAL,
	SHOW_ACTIONABLE_ERROR_MODAL,
	HIDE_ACTIONABLE_ERROR_MODAL,
	SHOW_UNACTIONABLE_ERROR_MODAL,
	HIDE_UNACTIONABLE_ERROR_MODAL
} from '../actions/actionsButtonFactory';
import {
	getNextStep,
	getPreviousStep,
	WIZARD_TOTAL_STEPS
} from '../utils/buttonFactoryUtils';
import {
	transformServerFormatToClient
} from '../lib/buttonModel';
import { getServerProps } from '../utils/serverProps';
import _get from 'lodash/get';
import { getOptionsForLanguageField } from '../components/WizardStep1';

const settingsLogoUrl = getSettingsLogoUrl();

const getDefaultValueForLanguage = () => {
	const serverProps = getServerProps();
	const countryAndLanguageDetails = _get(serverProps, 'countryAndLanguageDetails');
	const selectedCountry = _get(serverProps, 'selectedCountry');
	const languages = getOptionsForLanguageField(countryAndLanguageDetails, selectedCountry);
	// Get first language
	let language = _get(languages, '[0].value');
	return language || 'en';
}

export const initialState = {
	formattedButton: {
		countryCode: getServerProps().country,
		language: getDefaultValueForLanguage(),
		usePaypalButtonStyle: 'yes',
		buttonSize: 'large',
		showAcceptedCardLogos: true,
		allowPrograms: 'No',
		organizationName: getServerProps().organizationName,
		purpose: '',
		itemNumber: '',
		logoUrl: '',
		settingsLogoUrl,
		useSettingsLogo: settingsLogoUrl ? 'yes' : 'no',
		amountType: 'variable',
		amountValue: '',
		recurringEnabled: 'yes',
		receiverCurrency: getServerProps().primaryCurrency[0],
		noShipping: 'yes',
		noNote: 'no',
		extraVariables: {},
		extraVariablesView: '',
		accountIdentifierType: 'merchantAccountId',
		uploadNewLogo: 'no',
		merchantAmount1: '',
		merchantAmount2: '',
		merchantAmount3: '',
		listPrograms: 'no',
		programNames: []
	}
};

const defaultState = {
	currentStep: 1,
	totalSteps: WIZARD_TOTAL_STEPS,
	busy: true, // We fetch button on load, hence set this to busy
	customVariable: '<!DOCTYPE html>',
	waiting: false,
	showLoginModal: true,
	showUnactionableErrorModal: false,
	showActionableErrorModal: false
}

function getFormattedButton(payload) {
	// organizationName is not stored in BF service
	// fetching from server to make sure it gets pre-filled when user is editing/duplicating a button
	return Object.assign({}, transformServerFormatToClient(payload), {
		organizationName: getServerProps().organizationName,
		language: payload.language
	});
}
function getSettingsLogoUrl() {
	const merchantExperienceUrl = _get(getServerProps(), 'merchantExperienceUrls.logoUrl');
	const businessImageUrl = _get(getServerProps(), 'businessImageUrls.url');

	return merchantExperienceUrl ?
		merchantExperienceUrl :
		businessImageUrl;
}

export default function buttonFactory(state = defaultState, action) {
	switch (action.type) {
		case BUTTON_FACTORY_BUSY: {
			return {
				...state,
				busy: true
			}
		}

		case INITIALIZE_WIZARD: {
			const button = action.payload;
			let clientSideState = initialState;
			if (button) {
				clientSideState = {
					formattedButton: getFormattedButton(button)
				}
			}

			return {
				...state,
				button: action.payload,
				...clientSideState,
				busy: false
			}
		}

		case WIZARD_CONTINUE: {
			const { currentStep } = state;

			return {
				...state,
				currentStep: getNextStep(currentStep)
			}
		}

		case WIZARD_BACK: {
			const { currentStep } = state;

			return {
				...state,
				currentStep: getPreviousStep(currentStep)
			}
		}

		case WIZARD_SET_CURRENT_PAGE: {
			return {
				...state,
				currentStep: action.payload
			}
		}

		case CREATE_BUTTON_SUCCESS: {
			return {
				...state,
				button: action.payload,
				formattedButton: getFormattedButton(action.payload),
				busy: false,
				error: null
			}
		}

		case CREATE_BUTTON_ERROR: {
			const { error } = action.payload;

			return {
				...state,
				error,
				busy: false
			}
		}

		case EDIT_BUTTON_SUCCESS: {
			return {
				...state,
				button: action.payload,
				formattedButton: getFormattedButton(action.payload),
				busy: false,
				error: null
			}
		}

		case EDIT_BUTTON_ERROR: {
			const { error } = action.payload;

			return {
				...state,
				error,
				busy: false
			}
		}

		case GET_BUTTON_DATA_SUCCESS: {
			const newState = {
				...state,
				button: action.payload,
				formattedButton: getFormattedButton(action.payload),
				busy: false
			}
			return newState;
		}

		case GET_BUTTON_DATA_ERROR: {
			const { error } = action.payload;

			return {
				...state,
				error,
				busy: false
			}
		}

		case UPDATE_CODE_SNIPPET: {
			return {
				...state,
				customVariable: action.payload
			}
		}

		case TURN_ON_SPINNER: {
			return {
				...state,
				waiting: true
			}
		}

		case TURN_OFF_SPINNER: {
			return {
				...state,
				waiting: false
			}
		}

		case SHOW_LOGIN_MODAL: {
			return {
				...state,
				showLoginModal: true
			}
		}

		case HIDE_LOGIN_MODAL: {
			return {
				...state,
				showLoginModal: false
			}
		}

		case SHOW_ACTIONABLE_ERROR_MODAL: {
			return {
				...state,
				showActionableErrorModal: true
			}
		}

		case HIDE_ACTIONABLE_ERROR_MODAL: {
			return {
				...state,
				showActionableErrorModal: false
			}
		}

		case SHOW_UNACTIONABLE_ERROR_MODAL: {
			return {
				...state,
				showUnactionableErrorModal: true
			}
		}

		case HIDE_UNACTIONABLE_ERROR_MODAL: {
			return {
				...state,
				showUnactionableErrorModal: false
			}
		}

		default: return state;
	}
}



// WEBPACK FOOTER //
// ./buttons/reducers/reducerButtonFactory.js